import React, { useEffect } from "react";
import { getPlanGroups } from '../../../slices/plangroups'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import PlanForm from "../../../components/forms/plan-form";

const PlanDetail = () => {

    const dispatch = useDispatch()
    const selectedPlan = useSelector((state) => state.plans.selectedPlan)
    const loadingDetail = useSelector((state) => state.plans.loadingDetail)
    const planGroups = useSelector((state) => state.plangroups.results)

    useEffect(() => {
        dispatch(getPlanGroups())
    }, [])

    return (
        <>
            {selectedPlan &&
                <>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col px-0">
                                <h1 className="title">{selectedPlan.name}</h1>
                            </div>
                        </div>
                    </div>
                    { loadingDetail ? 
                        <div className="loader top-50 start-50 position-absolute" role="status"></div>
                    :
                        <PlanForm plan={selectedPlan} planGroups={planGroups}/>
                    }
                </>
            }
        </>
    )

}

export default PlanDetail